"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { SvgIconType } from '../../../SvgIcon/svg-icon-type.mjs';
import { DropdownCategoryType, dropdownCategoryConfig } from '../../shared.mjs';
import { ValueType } from '../../value-spec.mjs';
import { filterOptionsByLabel } from '../utils.mjs';
import { formulaConfigMapping } from './config-mapping.mjs';

class FormulaListOptionsFactory {
  async getOptions({ input, spec }) {
    const formulaTypes = getFormulaTypesForSpec(spec);
    const options = [];
    for (const type of formulaTypes) {
      const formulaSpec = formulaConfigMapping[type];
      options.push({
        label: formulaSpec.name,
        value: {
          [`$${type}`]: null
        },
        childCategory: DropdownCategoryType.FORMULA_CONFIG,
        iconType: SvgIconType.ListOption
      });
    }
    const filteredOptions = filterOptionsByLabel(options, input);
    if (filteredOptions.length > 0) {
      filteredOptions.unshift({
        label: dropdownCategoryConfig[DropdownCategoryType.FORMULA].title,
        isSection: true
      });
    }
    return filteredOptions;
  }
}
function getFormulaTypesForSpec(spec) {
  const result = [];
  const entries = Object.entries(formulaConfigMapping);
  for (const [formulaType, formulaSpec] of entries) {
    if (!formulaSpec.appliesToSpec) {
      continue;
    }
    if (!spec?.type || spec.type === ValueType.ANY || formulaSpec.appliesToSpec(spec)) {
      result.push(formulaType);
    }
  }
  return result;
}

export { FormulaListOptionsFactory };
